export default {
  BackNoEdit: '編集せずに戻る',
  BackNoCopy: '複製せずに戻る',
  BackToList: '一覧に戻る',
  BackToCreatives: '配信する画面に戻る',
};
